var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.html.type && _vm.html.elements ? _c('fragment', _vm._l(_vm.html.elements, function (el, idx) {
    var _ref;
    return _c('fragment', {
      key: idx
    }, [el.type === _vm.ElementTypes.ELEMENT ? _c('html-renderer', {
      key: (el + "-" + idx),
      style: el.attributes && el.attributes.style && (_ref = {}, _ref[el.attributes.style.split(':')[0]] = el.attributes.style.split(':')[1], _ref),
      attrs: {
        "htmlObject": el,
        "onClick": _vm.onClick,
        "getTextClass": _vm.getTextClass,
        "isPickTheAnswer": _vm.isPickTheAnswer
      }
    }) : _vm._e()], 1);
  }), 1) : _vm.html.type === _vm.ElementTypes.ELEMENT ? _c(_vm.elementNameSelector(_vm.html.name), {
    tag: "component",
    staticClass: "topComponent"
  }, _vm._l(_vm.html.elements, function (el, index) {
    var _ref2;
    return _c('fragment', {
      key: index
    }, [el.type === _vm.ElementTypes.ELEMENT ? _c('html-renderer', {
      style: el.attributes && el.attributes.style && (_ref2 = {}, _ref2[el.attributes.style.split(':')[0]] = el.attributes.style.split(':')[1], _ref2),
      attrs: {
        "htmlObject": el,
        "onClick": _vm.onClick,
        "getTextClass": _vm.getTextClass,
        "isPickTheAnswer": _vm.isPickTheAnswer
      }
    }) : _c('span', {
      class: _vm.maybeHighlightClass(el.index, el),
      attrs: {
        "id": el.type === _vm.ElementTypes.WORD ? ("word-" + (el.index)) : ("text-" + (el.index))
      },
      on: {
        "click": function () {
          return _vm.maybeHandleOnClick(el.index);
        }
      }
    }, [_vm._v(_vm._s(el.text))])], 1);
  }), 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }